export const osStandardFilterFields = [
	'materialId',
	'organizationId',
	'sku',
	'name',

	'propertyType',
	'propertyValues',

	'materialCategoryId',
	'categoryRef',

	'priceUnitId',
	'priceUnit',
	'priceUnitRef',

	'stockStatus',
	'stockStatusRef',

	'materialTemplateId',
	'materialTemplateRef',
] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
